import React, { Component } from 'react';
import GroupsMembers from './GroupsMembers';
export default class Troops extends Component{
    render() {
        console.log("pod_email",this.props.group)
        return (
            <div style={{"margin":"5px"}}>
                {this.props.group ? 
               <div class="panel-group margin_bottom_less" id="accordion" role="tablist" aria-multiselectable="true">
                    {
                        this.props.group.map((data, sequence) =>
                        <div class="panel panel-default">
                            {/*<a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href={"#"+ data.group_data['id']} aria-expanded="false" aria-controls="collapseOne">*/}
                            <div class="tab-system">
                                <div class="post-tab-system">
                                    <div class="tab-system-top">
                                            <div class="newpod-title"><a href={"/viewGroups/"+ data.group_data['email']}>{data.group_data['name']}</a></div>
                                            <div class="pro-mail">{data.group_data['email']}</div>
                                            {this.props.hr_permission == 'yes' ?
                                            <div class="pro-remove"><a class="pro-anchor" data-toggle="modal" data-target="#deleteEmployee" onClick={()=>this.props.parent.showRemoveEmployeeModal(this.props.group_data.id,this.props.group_data.name,data.group_data['name'],0,data.group_data['id'],this.props.group_type)}>Remove</a></div>
                                            :""}
                                            <div class="clear"></div>
                                    </div>
                                        {/*<div class="tab-system-bottom">
                                    {
                                        data.group_data['group_cnt'].map((g_cnt, sequence) =>
                                                <span>{g_cnt.count} {g_cnt.name} </span>
                                        )
                                    }
                                        </div>*/}
                                    </div>
                                    <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href={"#"+ data.group_data['id']} aria-expanded="false" aria-controls="collapseOne">
                                        <div class="rotate-icon">
                                            <i class="fal fa-chevron-down"></i>
                                        </div>
                                    </a>
                                </div>
                            {/*</a>*/}
                            <div id={data.group_data['id']} class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingOne">
                                <div class="tab-system-details">
                                    <div class="row">
                                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                            <div class="border-bottom pb20">
                                                <div class="descrip-title mb10">Description</div>
                                                <div class="tab-description">{data.group_data['description']}</div>
                                            </div>
                                            <GroupsMembers parent={this} group_data={data.group_data} apiUrl={this.props.apiUrl} userId={this.props.userId} userAuthKey={this.props.userAuthKey}  group_members ={data.group} hr_permission={this.props.hr_permission} groupEmail={this.props.groupId} fromTroop="1"/>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        )
                    }
                </div>
                : ""}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/hrAdmin/Troops.js